export default {
  init() {
		jQuery('.cmp_models').slick({
		  infinite: false,
		  slidesToShow: 3,
		  speed:2000,
		  draggable: false,
		  slidesToScroll: 3,
		  rtl: true,
		  arrows:true,
		  dots:true,
		  responsive: [
		    {
		      breakpoint: 649,
		      settings: {
		      	infinite: true,
		      	centerMode: true,
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        arrows:false,
		      }
		    },
		  ]
		});

    $('.our-models .child_models .content_models a').click(function () {
      jQuery('.our-models .child_models .content_models').each(function () {
        this.classList.remove('selected');
      });
      this.parentElement.classList.add('selected');
      $('.contact_popup_calculator').fadeIn().after('<div class="overlay_calc"></div>');
      var carName = jQuery('.our-models .child_models .content_models.selected h3')[0].innerText;
      var monthlyPrice = jQuery('.our-models .child_models .content_models p')[0].innerText;
      $('input[name="carModel"]')[0].value = carName;
      $('input[name="monthlyValue"]')[0].value = monthlyPrice;
    });
    $('.contact_popup_calculator .close_cal_pop_cont').click(function () {
      $('.contact_popup_calculator').fadeOut();
      $('.overlay_calc').fadeOut();
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/commercial.js